import React from 'react'
import { useIsAuthenticated } from 'react-auth-kit'
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom'

import Home from './pages/Home'
import SignInPage from './pages/SignIn';
import SignOut from './pages/SignOut';
import DashboardLayout from './layouts/Admin';
import Dashboard from './pages/Dashboard';
import Partners from './pages/Partners';
import {PartnerDetails} from './pages/PartnerDetails';
import Statistics from "./pages/Statistics";
import Terminals from "./pages/Terminals";
import {TransactionDetails} from "./pages/TransactionDetails";
import {TerminalDetails} from "./pages/TerminalDetails";
import Rates from './pages/Rates';

import { StatsIcon, CreditIcon, HomeIcon,} from "./components/Icons/Icons";

// import
import Transactions from './pages/Transactions';
import Menu from "./layouts/Menu";
import Limits from "./pages/Limits";
import {LimitDetails} from "./pages/LimitDetails";
import LimitCreate from "./pages/LimitCreate";
import LimitEdit from "./pages/LimitEdit";
import PartnerCreate from "./pages/PartnerCreate";
import PartnerEdit from "./pages/PartnerEdit";
import RateEdit from "./pages/RateEdit";
import {RateDetails} from "./pages/RateDetails";
import RateCreate from "./pages/RateCreate";
import RateShedule from "./pages/RateShedule";
import {TransactionAuditLog} from "./pages/TransactionAuditLog";


const RoutesComponent = () => {
    const PrivateRoute = ({ children, loginPath }) => {
        const isAuthenticated = useIsAuthenticated();
        const location = useLocation();

        if (isAuthenticated()) {
          return children;
        }
        localStorage.setItem('true_path', window.location.href);
        return <Navigate
          to={loginPath}
          state={{from: location}}
          replace
        />;
      };

    const MenuRoute = ({ children }) => {
        return children;

    };

    return (
        <BrowserRouter>
            <Routes>
                <Route path={'/'} element={<Home/>}/>
                <Route path={'/signout' } element={<SignOut/>}/>
                <Route path={'/admin_area/signin' } element={<SignInPage/>}/>
                <Route path={'/admin_area'} element={ <PrivateRoute loginPath="/admin_area/signin"> <DashboardLayout/></PrivateRoute>}>
                    <Route path={'dashboard'} element={<MenuRoute> <Dashboard/> <Menu/> </MenuRoute> } />
                    <Route path={'transactions'} element={<MenuRoute> <Transactions/> <Menu/> </MenuRoute> } />
                    <Route path={'partners'} element={<MenuRoute> <Partners/> </MenuRoute> } />
                    <Route path={'statistics'} element={<MenuRoute> <Statistics/> </MenuRoute> } />
                    <Route path={'partners/create'} element={<MenuRoute> <PartnerCreate/> <Menu/> </MenuRoute>} />
                    <Route path={'partners/edit/:id'} element={<MenuRoute> <PartnerEdit getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'terminals'} element={<MenuRoute> <Terminals/> </MenuRoute> } />
                    <Route path={'limits'} element={<MenuRoute> <Limits/> </MenuRoute> } />
                    <Route path={'limits/edit/:id'} element={<MenuRoute> <LimitEdit getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'transactions/:id'} element={<MenuRoute> <TransactionDetails getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'transactions/audit_log/:id'} element={<MenuRoute> <TransactionAuditLog/> <Menu/> </MenuRoute>} />
                    <Route path={'terminals/:id'} element={<MenuRoute> <TerminalDetails getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'partners/:id/:name/:login'} element={<MenuRoute> <PartnerDetails getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'limits/:id'} element={<MenuRoute> <LimitDetails getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'limits/create'} element={<MenuRoute> <LimitCreate/> <Menu/> </MenuRoute>} />
                    <Route path={'rates'} element={<MenuRoute> <Rates/> </MenuRoute>} />
                    <Route path={'rates/:id'} element={<MenuRoute> <RateDetails getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'rates/create'} element={<MenuRoute> <RateCreate/> <Menu/> </MenuRoute>} />
                    <Route path={'rates/edit/:id'} element={<MenuRoute> <RateEdit getAction={true}/> <Menu/> </MenuRoute>} />
                    <Route path={'rates/schedule'} element={<MenuRoute> <RateShedule/> </MenuRoute>} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default RoutesComponent

const routes =   [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: <HomeIcon color="inherit" />,
    layout: "/admin_area",
  },
  {
    path: "/transactions",
    name: "Транзакции",
    icon: <CreditIcon color="inherit" />,
    layout: "/admin_area",
  },
  {
    path: "/partners",
    name: "Партнёры",
    icon: <HomeIcon color="inherit" />,
    layout: "/admin_area",
  },
  {
    path: "/statistics",
    name: "Статистика",
    icon: <StatsIcon color="inherit" />,
    layout: "/admin_area",
  },
  {
    path: "/terminals",
    name: "Терминалы",
    icon: <HomeIcon color="inherit" />,
    layout: "/admin_area",
  },
  {
    path: "/limits",
    name: "Лимиты",
    icon: <HomeIcon color="inherit" />,
    layout: "/admin_area",
  },
  {
    path: "/rates",
    name: "Курс",
    icon: <CreditIcon color="inherit" />,
    layout: "/admin_area",
  },
]

export {routes}
